import { makeStyles } from "@material-ui/core/styles";
import AccessTimeIcon from "@material-ui/icons/AccessTime";
import ApartmentIcon from "@material-ui/icons/Apartment";
import BusinessCenterIcon from "@material-ui/icons/BusinessCenter";
import CalendarTodayIcon from "@material-ui/icons/CalendarToday";
import MonetizationOnIcon from "@material-ui/icons/MonetizationOn"; // Changed from AttachMoney to MonetizationOn for the icon in the image
import PeopleIcon from "@material-ui/icons/People";
import ShowChartIcon from "@material-ui/icons/ShowChart"; // For the Financial header icon
import StyleIcon from "@material-ui/icons/Style";
import { useState } from "react";
import { useSelector } from "react-redux";
// import EditBusinessInfoModal from "./EditBusinessInfoModal";
import DescriptionIcon from "@material-ui/icons/Description";
import EditBusinessInfoModal from "./EditBusinessInfoModal";
import Utils from "../../Helpers/Utils";
import { BUSINESS_CLASSIFICATION_OPTIONS } from "../../../../constants/CoreConstants";
import BootstrapTooltip from "../../../globals/BootstrapTooltip";
import CustomTitle from "../common/CustomTitle";

const useStyles = makeStyles((theme) => ({
  card: {
    width: "100%",
    borderRadius: "12px",
    backgroundColor: "#fff",
    boxShadow: "0 2px 8px rgba(0,0,0,0.06)",
    padding: "16px 6px",
    fontFamily: "sans-serif",
    borderTop: "4px solid #e7e9ff",
  },
  header: {
    display: "flex",
    fontWeight: 600,
    fontSize: "15px",
    color: "var(--accent-color) !important",
    marginBottom: "8px",
    padding: "0 0 8px 0",
  },
  chip: {
    display: "inline-block",
    backgroundColor: "#e0e7ff",
    color: "var(--accent-color) !important",
    fontWeight: 600,
    fontSize: "11px",
    padding: "2px 10px",
    borderRadius: "10px",
    marginBottom: "16px",
  },
  infoGrid: {
    display: "grid",
    gridTemplateColumns: "repeat(2, 1fr)",
    gap: "8px", // Gap between grid items
    fontSize: "13.5px",
    fontWeight: 600,
  },
  infoGridItem: {
    backgroundColor: "#f8f8f8", // Light gray background for each info item
    borderRadius: "8px",
    padding: "6px",
    overflow: "hidden",
  },
  infoLabel: {
    display: "flex",
    alignItems: "center",
    color: "#444",
    marginBottom: "4px", // Space between label and value
  },
  infoValue: {
    fontWeight: 600,
    color: "#000",
    width: "100%",
    maxWidth: "100%",
    overflow: "hidden",
    textOverflow: "ellipsis",
    whiteSpace: "nowrap",
  },
  divider: {
    height: "1px",
    background: "#eee",
    margin: "16px 0 10px",
  },
  financialHeader: {
    fontSize: "13px",
    fontWeight: 600,
    color: "#444",
    marginBottom: "10px",
    display: "flex",
    alignItems: "center",
  },
  financialRow: {
    borderRadius: "10px",
    padding: "8px 12px",
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
  },
  financialLabel: {
    display: "flex",
    alignItems: "center",
    fontWeight: 600,
    fontSize: "14px",
  },
  financialValue: {
    fontWeight: 700,
    fontSize: "14px",
  },
  revenueBg: {
    backgroundColor: "#e7fff1",
    marginBottom: "8px",
  },
  revenueText: {
    color: "#1a7f37",
  },
  payrollBg: {
    backgroundColor: "#e7f3ff",
  },
  payrollText: {
    color: "#0072c6",
  },
  // Specific icon colors
  classIcon: { color: "#1f9254" },
  startedIcon: { color: "#d32f2f" },
  expIcon: { color: "#ff6e00" },
  employeesIcon: { color: "#1976d2" },
  financialHeaderIcon: { color: "#1f9254" },
  hoverDiv: {
    "&:hover": {
      "& $icon": {
        opacity: 1,
        transition: "width .35s",
        width: "52px",
        display: "flex",
      },
    },
  },
  icon: {
    opacity: 0,
    width: 0,
    // display: "none",
  },
}));

const formatCurrency = (value) => {
  const formattedValue =
    Utils.formatCurrency(Utils.toZero(+value), "$") || "0.00";
  return formattedValue.toLocaleString("en-IN");
};

const BusinessInfo = () => {
  const { contact } = useSelector((state) => state.addContactReducer);
  const classes = useStyles();

  const convertArrayToObject = (array) => {
    try {
      if (!Array.isArray(array)) return {};

      const map = {};
      for (let i = 0; i < array.length; i++) {
        const item = array[i];
        if (item && item.id) {
          map[item.id] = item;
        }
      }
      return map;
    } catch {
      return {};
    }
  };
  const businessClassificationObject = convertArrayToObject(
    BUSINESS_CLASSIFICATION_OPTIONS
  );

  let content = null;

  if (contact?.contact_type === "COMMERCIAL" && contact?.business_information) {
    content = (
      <div className={classes.card}>
        <div className={classes.header}>
          <BusinessCenterIcon
            style={{ fontSize: "28px", marginRight: "6px" }}
          />
          <div>
            <div>{contact?.company_name || "N/A"}</div>

            <div className={classes.chip}>
              {contact?.business_information?.type_of_business || "N/A"}
            </div>
          </div>
        </div>

        <div className={classes.infoGrid}>
          <div className={classes.infoGridItem}>
            <div className={classes.infoLabel}>
              <ApartmentIcon style={{ fontSize: 16, marginRight: 4 }} />
              FEIN
            </div>
            <BootstrapTooltip
              arrow
              placement="top-center"
              title={contact?.business_information?.fein}
            >
              <div className={classes.infoValue}>
                {contact?.business_information?.fein || "N/A"}
              </div>
            </BootstrapTooltip>
          </div>
          <div className={classes.infoGridItem}>
            <div className={classes.infoLabel}>
              <StyleIcon
                style={{ fontSize: 16, marginRight: 4 }}
                className={classes.classIcon}
              />
              Classification
            </div>
            <BootstrapTooltip
              arrow
              placement="top-center"
              title={
                businessClassificationObject[
                  contact?.business_information?.business_classification
                ]?.display_name || ""
              }
            >
              <div
                className={classes.infoValue}
                style={{ color: classes.classIcon.color }}
              >
                {businessClassificationObject[
                  contact?.business_information?.business_classification
                ]?.display_name || "N/A"}
              </div>
            </BootstrapTooltip>
          </div>
          <div className={classes.infoGridItem}>
            <div className={classes.infoLabel}>
              <CalendarTodayIcon
                style={{ fontSize: 16, marginRight: 4 }}
                className={classes.startedIcon}
              />
              Started
            </div>
            <div className={classes.infoValue}>
              {contact?.business_information?.year_business_started || "N/A"}
            </div>
          </div>
          <div className={classes.infoGridItem}>
            <div className={classes.infoLabel}>
              <AccessTimeIcon
                style={{ fontSize: 16, marginRight: 4 }}
                className={classes.expIcon}
              />
              Experience
            </div>
            <div
              className={classes.infoValue}
              style={{ color: classes.expIcon.color }}
            >
              {contact?.business_information?.years_of_management_experience
                ? `${
                    contact.business_information.years_of_management_experience
                  } ${
                    contact.business_information
                      .years_of_management_experience == 1
                      ? "year"
                      : "years"
                  }`
                : "N/A"}
            </div>
          </div>

          <div className={classes.infoGridItem}>
            <div className={classes.infoLabel}>
              <PeopleIcon
                style={{ fontSize: 16, marginRight: 4 }}
                className={classes.employeesIcon}
              />
              Employees
            </div>
            <div
              className={classes.infoValue}
              style={{ color: classes.employeesIcon.color }}
            >
              {contact?.business_information?.number_of_employees || "N/A"}
            </div>
          </div>

          <div className={classes.infoGridItem}>
            <div className={classes.infoLabel}>
              <DescriptionIcon
                style={{ fontSize: 16, marginRight: 4 }}
                className={classes.employeesIcon}
              />
              DBA
            </div>
            <BootstrapTooltip
              arrow
              placement="top-center"
              title={contact?.business_information?.dba || ""}
            >
              <div
                className={classes.infoValue}
                style={{ color: classes.employeesIcon.color }}
              >
                {contact?.business_information?.dba || "N/A"}
              </div>
            </BootstrapTooltip>
          </div>
        </div>
        <div className={classes.divider}></div>
        <div className={classes.financialHeader}>
          <ShowChartIcon
            style={{ fontSize: 16, marginRight: 4 }}
            className={classes.financialHeaderIcon}
          />
          Financial
        </div>
        <div className={`${classes.financialRow} ${classes.revenueBg}`}>
          <div className={`${classes.financialLabel} ${classes.revenueText}`}>
            <MonetizationOnIcon style={{ fontSize: 16, marginRight: 6 }} />
            Revenue
          </div>
          <div className={`${classes.financialValue} ${classes.revenueText}`}>
            {contact?.business_information?.annual_revenue
              ? formatCurrency(contact.business_information.annual_revenue)
              : "N/A"}
          </div>
        </div>
        <div className={`${classes.financialRow} ${classes.payrollBg}`}>
          <div className={`${classes.financialLabel} ${classes.payrollText}`}>
            <MonetizationOnIcon style={{ fontSize: 16, marginRight: 6 }} />
            Payroll
          </div>
          <div className={`${classes.financialValue} ${classes.payrollText}`}>
            {contact?.business_information?.total_payroll
              ? formatCurrency(contact.business_information.total_payroll)
              : "N/A"}
          </div>
        </div>
      </div>
    );
  }

  const [openBusinessInfoModal, setOpenBusinessInfoModal] = useState(false);
  const handleOpen = () => {
    setOpenBusinessInfoModal(true);
  };

  return (
    <div style={{ marginTop: "16px" }}>
      {contact?.contact_type === "COMMERCIAL" && (
        <div className={classes.hoverDiv}>
          <div style={{ gap: 10, marginBottom: "16px" }}>
            <CustomTitle
              handleOpen={handleOpen}
              title={"BUSINESS INFORMATION"}
              iconHide={classes.icon}
            />
          </div>
          <div style={{ display: "flex" }}>{content}</div>
        </div>
      )}
      {openBusinessInfoModal && (
        <EditBusinessInfoModal
          open={openBusinessInfoModal}
          onClose={() => setOpenBusinessInfoModal(false)}
          contactBusinessInfo={contact?.business_information}
        />
      )}
    </div>
  );
};

export default BusinessInfo;
